import {IPhpConfigsState} from "../reducers/hosting-php-configs.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getPhpConfigsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.phpConfigs);

export const getPhpConfigs = (websiteId: number) => createSelector(getPhpConfigsState,
  (state: IPhpConfigsState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? state.entities[websiteId].entities : null
);

export const getPhpConfigsLoading = (websiteId: number) => createSelector(getPhpConfigsState,
  (state: IPhpConfigsState) =>
    state.entities[websiteId].loading
);

export const getPhpConfigsLoaded = (websiteId: number) => createSelector(getPhpConfigsState,
  (state: IPhpConfigsState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
